import React, { useState, useEffect } from "react";

const menstrualCycleOptions = [
  {
    value: "Regular",
    label: "Predictable, every 21-35 days)"
  },
  {
    value: "Irregular", 
    label: "Irregular, unpredictable, <21 and >35 days)"
  },
  {
    value: "No periods",
    label: "I don't have periods"
  }
];

const MenstrualCycleQuestion = ({ onSubmit, onNext, initialValue }) => {
  const [selectedOption, setSelectedOption] = useState("");

  // Set initial value when editing
  useEffect(() => {
    if (initialValue) {
      setSelectedOption(initialValue);
    }
  }, [initialValue]);

  const handleOptionChange = (option) => {
    setSelectedOption(option);
    // Don't auto-advance - user must click Continue button
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (!selectedOption) return;
    
    onSubmit(selectedOption);
    onNext();
    
    // Reset selection
    setSelectedOption("");
  };

  const canSubmit = selectedOption !== "";

  return (
    <form onSubmit={handleSubmit} className="input-form">
      <div className="menstrual-cycle-options-container">
        <div className="menstrual-cycle-options">
          {menstrualCycleOptions.map((option) => (
            <button
              key={option.value}
              type="button"
              className={`menstrual-cycle-button ${selectedOption === option.value ? 'menstrual-cycle-button-selected' : ''}`}
              onClick={() => handleOptionChange(option.value)}
            >
              <div className="option-content">
                <div className="option-value">{option.value}</div>
                <div className="option-description">{option.label}</div>
              </div>
            </button>
          ))}
        </div>
        <button
          type="submit"
          className="menstrual-cycle-submit-button"
          disabled={!canSubmit}
        >
          Continue
        </button>
      </div>
    </form>
  );
};

export default MenstrualCycleQuestion;
